import brand from "./brand.svg";
import brand_full from "./brand_full.svg";
import blending_mode from "./blending_mode.svg";
import search from "./search.svg";
import lock from "./lock.svg";
import arrow_top_right from "./arrow_top_right.svg";
import chevron_down from "./chevron_down.svg";
import link from "./link.svg";
import checked_circle from "./checked_circle.svg";
import close_circle from "./close_circle.svg";
import alert_circle from "./alert_circle.svg";
import arrow_down from "./arrow_down.svg";
import arrow_left from "./arrow_left.svg";
import arrow_right from "./arrow_right.svg";
import copy from "./copy.svg";
import chevron_left from "./chevron_left.svg";
import chevron_right from "./chevron_right.svg";
import checked from "./checked.svg";
import loader from "./loader.svg";

const svg = {
  brand: brand,
  brand_full: brand_full,
  blending_mode: blending_mode,
  search: search,
  lock: lock,
  arrow_top_right: arrow_top_right,
  chevron_down: chevron_down,
  link: link,
  checked_circle: checked_circle,
  close_circle: close_circle,
  alert_circle: alert_circle,
  arrow_down: arrow_down,
  arrow_left: arrow_left,
  arrow_right: arrow_right,
  copy: copy,
  chevron_left: chevron_left,
  chevron_right: chevron_right,
  checked: checked,
  loader: loader,
};

export type SvgName = keyof typeof svg;

export { svg };
